<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>자료실</li>
					<li>공지사항</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>공지사항</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<h3 class="conTit">공지사항</h3>
					<div class="conStyle1">
						<div class="info mgl0">
							<p>주의사항</p>
							<ol>
								<li>사고발생 시 보험증권상 기재된 통보처에 통보하시거나, 보험계약 담당 영업부점 통하여 접수처리 하시면 됩니다.</li>
								<li>접수 이후 배정된 담당자가 사고 내용 확인 후 필요 서류 등 별도 안내 드립니다.</li>
							</ol>
						</div>
					</div>
					<div class="tabStyle2">
						<table v-show='state.ind_corp_typ_cd=="C"'>
							<caption>공지사항</caption>
							<colgroup>
								<col width="100">
								<col width="*">
								<col width="122">
							</colgroup>
							<thead>
								<tr>
									<th scope="col" height="62">번호</th>
									<th scope="col">글내용</th>
									<th scope="col">등록일자</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(d, index) in state.notice" :key="index">
									<td height="74">{{d.SEQ}}</td>
									<td class="tal"><a @click="openPopup(d.SEQ)">{{d.SUBJECT}}</a></td>
									<td>{{d.STRT_YMD}}</td>
								</tr>
								
								<tr v-show='state.notice==""'>
									<td colspan="3">
										<p class="noData">조회된 결과가 없습니다.</p>
									</td>
								</tr>
							</tbody>
						</table>
						<button @click="openNewNoti()" v-show='state.ind_corp_typ_cd=="A"' class="btnType sizeS colorB"  style="
							width: 100px;
							float: right;
							margin: 10px 0px;
						"><span>글쓰기</span></button>
						<table v-show='state.ind_corp_typ_cd=="A"'>
							<caption>공지사항</caption>
							<colgroup>
								<col width="100">
								<col width="*">
								<col width="160">
								<col width="160">
								<col width="100">
							</colgroup>
							<thead>
								<tr>
									<th scope="col" height="62">번호</th>
									<th scope="col">글내용</th>
									<th scope="col">시작일자</th>
									<th scope="col">종료일자</th>
									<th scope="col">팝업</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(d, index) in state.notice" :key="index">
									<td height="74">{{d.SEQ}}</td>
									<td class="tal"><a @click="openChngNoti(d.SEQ)">{{d.SUBJECT}}</a></td>
									<td>{{d.STRT_YMD}}</td>
									<td>{{d.FIN_YMD}}</td>
									<td>{{d.NOTICE_TYP == 1 ? 'Y' : 'N'}}</td>

								</tr>
								
								<tr v-show='state.notice==""'>
									<td colspan="5">
										<p class="noData">조회된 결과가 없습니다.</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<PopNoti ref="PopNotiRef" @close="handlePopupClose"></PopNoti>

</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import util from '@/common/util';
import { sessionUserInfo, load } from '@/common/sessionFactory';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import PopNoti from '@/components/common/layerPop/PopNoti.vue';
import { globalState }  from "@/common/globalState";

const swalAlert = inject("swalAlert");
const handlePopupClose = () => {};
const PopNotiRef = ref(null);
const router = useRouter();  
const store = useStore();

const axios = inject('axios')
const state = reactive({
	notice : [],
	ind_corp_typ_cd : 'C'
});


const openPopup = (name) => {
	const param = {};
    param.seq = name;
	axios.json('/noticePop.do', param).then(function(result){
		PopNotiRef.value.open(result.data.notice);
	})

};

const openChngNoti = (item) => {
	store.commit('common/commitSeq', item)
	router.push({name: 'chngNotice'})
}

const openNewNoti = (item) => {
	const param = {};
	axios.json('/getMaxSeq.do', param).then(function(result){
		store.commit('common/commitSeq', result.data.seq)
		router.push({name: 'chngNotice'})
	})
}

onMounted(async () => {
	await load();
	console.log("공지사항",sessionUserInfo)
	if(!_.isEmpty(sessionUserInfo)){
		state.userInfo = rmSpaceObject(sessionUserInfo.userInfo);
		state.ind_corp_typ_cd = state.userInfo?.ind_corp_typ_cd;
		axios.json('/logHisLdg.do', {memo:"공지사항 조회" ,page:window.location.hash}).then(function(result){
			state.notice = result.data.notice;
		});
	}
    await axios.json('/noticeBd.do', {}).then(function(result){
		state.notice = result.data.notice;
	})
})



function rmSpaceObject(obj){
	return _.mapValues(obj, value => _.isString(value) ? _.trim(value) : value);
}


</script>

<style>

</style>

